import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { fetchAllApprovalList } from "../../../../services/fetchListingData";
import {
  ACTIVATE,
  APPROVED,
  INACTIVE,
  REJECTED,
  STATUS_CODE_200,
} from "../../../../utility/constants/valueConstants";
import ResizeListner from "../../../../utility/ResizeListner";
import {
  DeactivatedListHeaders,
  PendingListHeaders,
} from "../../../../utility/TableHeaders";
import CustomModal from "../../../components/main_comps/custom_modal";
import CustomTable from "../../../components/main_comps/custom_table";
import ViewMoreApproval from "../../../components/ui_comps/approval_comps/ViewMoreApproval";
import { useSnackbar } from "notistack";
import moment from "moment";

function DeactivatedAccount() {
  const { width, height } = ResizeListner();
  const [data, setData] = useState([]);
  const [totalElements, setTotalElements] = useState(100);
  const [totalPages, setTotalPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.globalFiltersSlice);
  const [clientData, setClientData] = useState(false);
  const [onClickViewMore, setOnClickViewMore] = useState("");
  const approvalData = useSelector((state) => state.listingSlice.approvalList);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const onClickApproveReject = (clientId, status) => {
    setLoading(true);
    ApiRequestPost.adminApproveRejectAction({
      clientId,
      status,
      isCancelled: false,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          setOnClickViewMore(false);
          dispatch(
            fetchAllApprovalList({
              dateRange: "",
              page: 0,
              size: 10,
              activeStatus: INACTIVE,
              onBoardedStatus: APPROVED,
              userRefId: "",
            })
          );
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };
  useEffect(() => {
    dispatch(
      fetchAllApprovalList({
        dateRange: "",
        page: 0,
        size: 10,
        activeStatus: INACTIVE,
        onBoardedStatus: APPROVED,
        userRefId: "",
        deactivatedList: true,
      })
    );
  }, []);

  return (
    <div>
      <div style={{ padding: "0px 20px", overflow: "hidden" }}>
        <CustomTable
          styles={{
            maxHeight: height * 0.7,
            minHeight: height * 0.7,
          }}
          data={approvalData?.clients}
          currentPage={approvalData?.currentPageNo - 1}
          headers={DeactivatedListHeaders}
          totalElements={approvalData?.totalRecords}
          totalPages={approvalData?.totalPages}
          handlePaginate={(page) => {
            //setCurrentPage(page);
            dispatch(
              fetchAllApprovalList({
                //dateRange: "",
                dateRange:
                  filters?.fromDate && filters?.toDate
                    ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                      "-" +
                      moment(filters?.toDate).format("DD/MM/YYYY")
                    : "",

                page: page + 1,

                size: 10,
                activeStatus: INACTIVE,
                onBoardedStatus: APPROVED,
                userRefId: "",
                deactivatedList: true,
              })
            );
          }}
          onViewMore={(row) => {
            setClientData(row);

            setOnClickViewMore(true);
          }}
        />
      </div>

      {onClickViewMore && (
        <CustomModal
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
          open={onClickViewMore}
          isBackRequired={false}
          isHeaderRequired={false}
          onClose={() => {
            setOnClickViewMore(false);
          }}
        >
          <ViewMoreApproval
            onClose={() => {
              setOnClickViewMore(false);
            }}
            data={clientData}
            isButtonsRequired={false}
            onSuccess={() => {
              setOnClickViewMore(false);
              dispatch(
                fetchAllApprovalList({
                  dateRange: "",
                  page: 0,
                  size: 10,
                  activeStatus: INACTIVE,
                  onBoardedStatus: APPROVED,
                  userRefId: "",
                })
              );
            }}
            isActiveButtonRequired={true}
            onClickApproveReject={(userId) => {
              onClickApproveReject(userId, ACTIVATE);
            }}
            loading={loading}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default DeactivatedAccount;
